module.exports = __webpack_public_path__ + "img/9788952755445.598bbed5.jpg";